const EXPO_IMG = "/images/expo.webp";

const ITEMS = [
  {
    n: "01",
    t: "Frontier, not folklore.",
    b: "Speakers who ship. Research that matters. What actually changed in the last twelve months.",
  },
  {
    n: "02",
    t: "Strategy meets practice.",
    b: "The people making the decisions and the people making the systems, in one room.",
  },
  {
    n: "03",
    t: "A Nordic vantage point.",
    b: "Governance, energy, capital and craft. Held to a high standard.",
  },
];

export default function WhyAttend() {
  return (
    <section id="why" data-testid="why-attend-section" className="section border-t border-[var(--rule)]">
      <div className="max-w-page container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 md:mb-16">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="section-index">02</span>
              <span className="eyebrow" data-testid="why-eyebrow">Who this is for</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl md:text-6xl leading-[0.98] tracking-[-0.02em] max-w-[18ch]">
              A working room, not a broadcast.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9 flex md:items-end">
            <p className="text-[14px] md:text-[15px] leading-[1.55] text-[var(--fg-muted)] max-w-[38ch]">
              For people building frontier AI and people putting it to work.
              One day. One city. No filler.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-start border-t border-[var(--rule)] pt-10 md:pt-14">
          <div className="md:col-span-7">
            <div className="aspect-[4/3] md:aspect-[16/11] w-full overflow-hidden bg-[var(--bg-2)]">
              <img
                src={EXPO_IMG}
                alt="Delegates meeting between sessions on the expo floor"
                loading="lazy"
                className="w-full h-full object-cover img-editorial"
                data-testid="why-image"
              />
            </div>
            <p className="text-[12px] text-[var(--fg-muted)] mt-3">
              Between sessions — where decisions actually get made.
            </p>
          </div>

          <div className="md:col-span-5 flex flex-col divide-y divide-[var(--rule-soft)]">
            {ITEMS.map((r, i) => (
              <div
                key={r.n}
                className={`flex flex-col ${i === 0 ? "pb-8" : "py-8"}`}
                data-testid={`why-item-${r.n}`}
              >
                <span className="tick-num mb-3">{r.n}</span>
                <h3 className="font-display text-2xl md:text-[26px] leading-[1.1] tracking-[-0.01em] mb-3">
                  {r.t}
                </h3>
                <p className="text-[14px] md:text-[15px] text-[var(--fg-muted)] leading-[1.55] max-w-[42ch]">
                  {r.b}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
